<template>
  <ComponentHeader title="Entity Creator" subtitle="Manually create new entities with custom attributes and relationships">
    <button
        @click="showModal = true"
        class="btn-primary"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
        Create New Entity
      </button>
  </ComponentHeader>

  <div class="entity-creator p-4">
        <div class="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h4 class="text-sm font-semibold text-blue-900 mb-2">Entity Creation Steps</h4>
          <ol class="text-sm text-blue-800 space-y-1 list-decimal list-inside">
            <li>Enter basic information (name and type)</li>
            <li>Add identifiers (NPI, TIN, MRN, etc.)</li>
            <li>Assign parent entities for hierarchical relationships</li>
            <li>Fill in custom attributes</li>
          </ol>
    </div>

    <!-- Entity Form Modal -->
    <FormEntity
      v-if="showModal"
      :is-visible="showModal"
      @close="showModal = false"
      @update="onEntityCreated"
    />
  </div>
</template>

<script>
import FormEntity from '@/components/forms/Form_Entity.vue';
import ComponentHeader from '@/components/widgetcomponents/library/ComponentHeader.vue';

export default {
  name: 'EntityCreator',

  components: {
    FormEntity,
    ComponentHeader
  },

  data() {
    return {
      showModal: false
    };
  },

  methods: {
    onEntityCreated() {
      this.showModal = false;
      // Could emit an event here if needed
      this.$emit('entity-created');
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
